import { render, staticRenderFns } from "./HighLights.vue?vue&type=template&id=046563e8&scoped=true&"
import script from "./HighLights.vue?vue&type=script&lang=js&"
export * from "./HighLights.vue?vue&type=script&lang=js&"
import style0 from "./HighLights.vue?vue&type=style&index=0&id=046563e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046563e8",
  null
  
)

export default component.exports